module.exports = __webpack_public_path__ + "static/img/eu_logo.8e789a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link-logo/eu_logo.jpg
// module id = wDVQ
// module chunks = 1